import React from "react";
import { BrainCircuitIcon, CalendarDaysIcon, GiftIcon, LineChartIcon, ScanLineIcon, UmbrellaIcon, BoxIcon } from "lucide-react";
type Bonus = {
  icon: BoxIcon;
  title: string;
  value: string;
  description: string;
  imageUrl: string;
};
const bonuses: Bonus[] = [{
  icon: ScanLineIcon,
  title: 'Video Analisi Pro',
  value: 'Valore €12',
  description: 'Correzione tecnica istantanea con lo smartphone. Fai vedere l’errore per correggerlo 3x più veloce.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/wuCzK6zGykb15FPqtBpk7E/60144052-9124-4e1c-b1aa-433d64df1bd7-mockup.webp'
}, {
  icon: CalendarDaysIcon,
  title: 'La Roadmap delle 52 Settimane',
  value: 'Valore €20',
  description: 'Una mappa annuale visiva: sai esattamente quale volume e quale lezione dare ogni settimana.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/36sTyqDd6x7vXdiBkhAymf/0f2c2dc6-30b7-4ef3-a6d2-6a4d86d45d87-mockup.webp'
}, {
  icon: UmbrellaIcon,
  title: 'Pioggia Pronta',
  value: 'Valore €25',
  description: '50 esercizi per spazi ridotti. Non annullare mai più una lezione a causa del maltempo.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/8MUCN7ufYkoxPaTe98ndjp/e2e0f140-b65d-4363-98d2-9238c33f54c9-mockup.webp'
}, {
  icon: LineChartIcon,
  title: 'L’Excel del Maestro',
  value: 'Valore €15',
  description: 'Gestione professionale di pagamenti, presenze e cash flow. Basta foglietti sparsi.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/oyu3X5t4CVQVaQSfL38xPq/2fa2d0b2-49c4-44df-8761-143dfa9d3d78-mockup.webp'
}, {
  icon: BrainCircuitIcon,
  title: 'Tennis Mindset 101',
  value: 'Valore €15',
  description: 'Protocolli psicologici per vincere prima con la testa e poi con il corpo.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/hZqjm8DCPqwnLfm5r6m9qu/605a134d-75f5-4191-829d-306892ab2430-mockup.webp'
}];
export function BonusSection() {
  return <section className="bg-[#101a12] px-5 py-20" data-id="element-1" data-mp="3h5mw78b6ntpv">
      <div className="mx-auto max-w-5xl" data-id="element-2" data-mp="3h4bs17dtsjy8">
        <div className="text-center" data-id="element-3" data-mp="1h3f0vkstj13j">
          <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-emerald-300" data-id="element-4" data-mp="1h2cb5g78f4p7">
            <GiftIcon className="h-4 w-4" data-id="element-5" data-mp="1c3snnbczpkuq" />
            Inclusi oggi senza costi aggiuntivi
          </p>
          <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-6" data-mp="1q3jyx4c4gn51">
            Cinque bonus <span className="text-emerald-300" data-id="element-7" data-mp="1m0nklptm7d6w">strategici</span>
          </h2>
          <p className="mt-4 text-sm font-medium text-slate-300" data-id="element-8" data-mp="yd5oji3bhsy4">
            Valore reale del pack bonus: €87 — oggi inclusi GRATIS con Tennis
            Pronto.
          </p>
        </div>
        <div className="mt-11 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-9" data-mp="176shz1k1yk45">
          {bonuses.map(({
          icon: Icon,
          title,
          value,
          description,
          imageUrl
        }, index) => <article key={title} className="overflow-hidden border border-emerald-200/20 bg-[#1b2b1e]" data-id="element-10" data-mp="en3ppsr5v2qm" data-mpi={index}>
              <img src={imageUrl} alt={`Mockup del bonus: ${title}`} width={1024} height={1024} loading="lazy" className="aspect-square w-full object-cover" data-id="element-11" data-mp="an32bim33h7f" />
              <div className="p-6" data-id="element-12" data-mp="5ad2nbu83i2y">
                <div className="flex items-center justify-between gap-4" data-id="element-13" data-mp="5bfq19sc72e4">
                  <span className="grid h-11 w-11 place-items-center border border-emerald-300/40 bg-emerald-400/10" data-id="element-14" data-mp="3mrxk6i85gc7j">
                    <Icon className="h-5 w-5 text-emerald-300" data-id="element-15" data-mp="3rpz415degfk2" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-widest text-emerald-300" data-id="element-16" data-mp="jafeohfunhaa">
                    Bonus {String(index + 1).padStart(2, '0')}
                  </p>
                </div>
                <div className="mt-6" data-id="element-17" data-mp="9b6lvrwq08pi">
                  <span className="border border-emerald-300/40 px-2 py-1 text-[10px] font-bold uppercase text-emerald-200" data-id="element-18" data-mp="easyq08mzmxs">
                    {value} — Gratis oggi
                  </span>
                  <h3 className="mt-4 text-lg font-bold text-white" data-id="element-19" data-mp="2u4a1j8qfvvnj">{title}</h3>
                  <p className="mt-2 text-sm font-medium leading-relaxed text-slate-300" data-id="element-20" data-mp="2z2bk7sjydsyh">
                    {description}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}